<div class="my-reports-container">
  <span class="time-disclaimer" *ngIf="isSomeReportInProgress"
    >Your report shall be ready in 3 minutes</span
  >

  <div *ngIf="requestedReports.length > 0; else noReports">
    <mat-table #table [dataSource]="requestedReports" class="table-desktop">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>Name</mat-header-cell>
        <mat-cell *matCellDef="let element" (click)="handleLinkClick(element)">
          <span
            [ngClass]="element.url ? 'text-underline link-like-text' : ''"
            >{{ element.name }}</span
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="type">
        <mat-header-cell *matHeaderCellDef>Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span>{{ reportTitle(element.type) }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="date">
        <mat-header-cell *matHeaderCellDef>Date</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [matTooltip]="element.orderedAt | utcToLocal: 'MM/dd/yyyy, h:mm'"
          matTooltipPosition="above"
          matTooltipClass="tooltip"
        >
          {{ element.orderedAt | utcToLocal: 'MM/dd/yyyy' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="status">
        <mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [ngClass]="
            element.status === ReportStatus.READY
              ? 'ready'
              : element.status === ReportStatus.PAYMENT_ERROR ||
                  element.status === ReportStatus.AUTOMATION_ERROR
                ? 'payment-error'
                : 'in-progress'
          "
          [matTooltip]="element.status | reportStatusToTooltip"
        >
          {{ element.status | statusToText }}
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="['name', 'type', 'date', 'status']"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: ['name', 'type', 'date', 'status']"
      ></mat-row>
    </mat-table>

    <div
      *ngFor="let report of requestedReports; let i = index"
      class="report-status-mobile"
    >
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="text-content-title">
            <span
              (click)="handleLinkClick(report)"
              [ngClass]="report.url ? 'text-underline link-like-text' : ''"
              >{{ report.name }}</span
            >
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="text-content">
          <span>{{ report.orderedAt | date: 'MM/dd/yyyy' }}</span>
          <span
            [ngClass]="
              report.status === ReportStatus.READY ? 'ready' : 'in-progress'
            "
            >{{ $any(report).status | statusToText }}</span
          >
        </div>
      </mat-expansion-panel>
      <mat-divider *ngIf="i < requestedReports.length - 1"></mat-divider>
    </div>
  </div>

  <ng-template #noReports>
    <div class="no-reports">
      <span class="no-reports-disclaimer">
        All your reports are kept here so you can access them anytime. Now you
        have no reports!</span
      >
      <a routerLink="/reports/order" class="link-like-text">
        <app-icon
          svgIcon="report"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: false }"
        ></app-icon>
        <span class="text-underline link-like-text"
          >Let’s order the first report</span
        >
      </a>
    </div>
  </ng-template>
</div>
